import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ThemeProvider from '@ds/components/ThemeProvider'
import { baseUrl } from '../utils/assets'

const queryClient = new QueryClient()

const Root = ({ children }: React.PropsWithChildren) => {
    return (
        <ThemeProvider themeOptions={{ assetsBaseUrl: baseUrl }}>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ThemeProvider>
    )
}

export default Root
